/* BREEZE · Liquid Glass · assistente acquisti (il pallino in basso a destra)
   Il widget vive in una "shadow root" e non riceve il CSS del tema: questo
   piccolo script inserisce lo stile direttamente dentro. Solo aspetto:
   comportamento e animazioni del widget restano quelli originali. */
(function () {
  var CSS = [
    '[data-testid=entrypoint] .entrypoint-shadow.size-12{width:40px!important;height:40px!important;box-shadow:inset 0 0 0 1px rgba(255,255,255,.35),inset 1.5px 1.5px 3px rgba(255,255,255,.35),inset -1.5px -1.5px 4px rgba(0,0,0,.45),0 8px 20px -8px rgba(0,0,0,.6)!important}',
    '[data-testid=entrypoint] .agent-avatar-bg{background:linear-gradient(135deg,rgba(60,60,64,.78),rgba(18,18,18,.86))!important;-webkit-backdrop-filter:blur(16px) saturate(170%);backdrop-filter:blur(16px) saturate(170%)}',
    '[data-testid=entrypoint] .agent-avatar-bg svg{width:18px!important;height:18px!important}',
    '[data-testid=entrypoint] .entrypoint-shadow::after{content:"";position:absolute;inset:0;border-radius:50%;pointer-events:none;background:linear-gradient(105deg,rgba(255,255,255,0) 35%,rgba(255,255,255,.35) 50%,rgba(255,255,255,0) 65%);background-size:260% 100%;background-position:130% 0;background-repeat:no-repeat;animation:agGlint 6s ease-in-out infinite}',
    '@keyframes agGlint{0%{background-position:130% 0}30%{background-position:-130% 0}100%{background-position:-130% 0}}'
  ].join('\n');

  function apply() {
    var host = document.getElementById('ads-agent-host');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById('glass-agent')) return true;
    var st = document.createElement('style');
    st.id = 'glass-agent';
    st.textContent = CSS;
    host.shadowRoot.appendChild(st);
    return true;
  }

  if (apply()) return;
  var tries = 0;
  var timer = setInterval(function () {
    if (apply() || ++tries > 60) clearInterval(timer);
  }, 500);
})();
